'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RecommendationItem = require('./components/RecommendationItem.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RecommendationItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/recommendation-item/lib/index.js
// module id = 1459
// module chunks = 1